(function () {
  'use strict';

  /* @ngdoc object
   * @name trainingPrograms
   * @description
   *
   */
  angular
    .module('trainingPrograms', [
      'ui.router'
    ]);
}());
